<!-- CONSULTAS → CUOTAS A MEDIAS (D2-bis, CPC-88). -->
<section class="kb-card">
  <div class="kb-card-header">
    <div>
      <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-hourglass-half text-muted-foreground" aria-hidden="true"></i>Cuotas a medias</h2>
      <p class="kb-card-desc">Cuotas que se le liquidan al comercio cuando el cliente termina de pagarlas y que todavía tienen abonos sin completar. Es la foto del cierre del día; los días esperando cuentan desde el primer abono.</p>
    </div>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="descargar()" [disabled]="descargando || !r?.dia">
      <i class="fas fa-file-excel" aria-hidden="true"></i>{{ descargando ? 'Descargando…' : 'Excel' }}</button>
  </div>

  <div class="flex flex-col gap-[16px] px-[24px] pb-[20px]">
    <div class="flex flex-wrap items-end gap-3">
      <label class="kb-label" for="cmDia">Día del cierre
        <input type="date" class="kb-input !w-[170px]" id="cmDia" [(ngModel)]="f.dia" (change)="buscar()">
      </label>
      <label class="kb-label" for="cmComercio">Comercio
        <select class="kb-select !w-[200px]" id="cmComercio" [(ngModel)]="f.comercio" (change)="buscar()">
          <option value="">Todos los comercios</option>
          <option *ngFor="let c of r?.resumen?.por_comercio" [value]="c.code">{{ c.code }}</option>
        </select>
      </label>
    </div>

    <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
      <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
    </div>
    <app-cargando-cuadros class="block px-0 py-0" *ngIf="cargando && !filas.length" [filas]="4" [envuelto]="false"></app-cargando-cuadros>
    <p class="kb-hint" *ngIf="r && r.dia && !r.cerrado">El día {{ r.dia }} todavía no está cerrado: su foto sale al cerrarlo.</p>

    <div class="kb-cifras" *ngIf="r?.resumen">
      <div><p class="kb-dato-et">Esperan la cuota</p>
        <p class="kb-dato-val tabular-nums"><app-monto-bs [usd]="totalVisto" [bs]="bs(totalVisto)" [tasa]="r.tasa_bcv" parte="principal"></app-monto-bs></p>
        <p class="kb-dato-nota"><app-monto-bs [usd]="totalVisto" [bs]="bs(totalVisto)" [tasa]="r.tasa_bcv" parte="secundaria" subClass=""></app-monto-bs> · cuadra con «espera la cuota» del cuadre</p></div>
      <div><p class="kb-dato-et">Cuotas</p><p class="kb-dato-val tabular-nums">{{ cuotasVistas }}</p>
        <p class="kb-dato-nota">foto del cierre del {{ r.dia }}</p></div>
      <div *ngFor="let c of r.resumen.por_comercio"><p class="kb-dato-et">{{ c.code }}</p>
        <p class="kb-dato-val tabular-nums"><app-monto-bs [usd]="c.abonado" [bs]="bs(c.abonado)" [tasa]="r.tasa_bcv" parte="principal"></app-monto-bs></p>
        <p class="kb-dato-nota">{{ c.cuotas }} cuota(s) · $ {{ c.abonado | number:'1.2-2':'es' }}</p></div>
    </div>
  </div>

  <div class="kb-empty" *ngIf="r && !cargando && !filas.length && !error">
    <span class="kb-empty-icono"><i class="fas fa-check" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">Ninguna cuota esperando</p>
    <p class="kb-empty-texto">{{ r.dia ? 'En la foto del cierre del ' + r.dia + ' no quedó ninguna cuota a medias.' : 'Todavía no hay un día cerrado con su foto.' }}</p>
  </div>

  <div class="kb-table-envoltorio" *ngIf="filas.length">
    <table class="kb-table">
      <thead class="kb-thead"><tr>
        <th class="kb-th">Comercio</th><th class="kb-th">Venta</th><th class="kb-th">Cliente</th><th class="kb-th">Cuota</th>
        <th class="kb-th kb-th-num">Monto original</th><th class="kb-th kb-th-num">Abonado</th><th class="kb-th kb-th-num">Falta</th>
        <th class="kb-th kb-th-num">Abonos</th><th class="kb-th">Primer abono</th><th class="kb-th">Último abono</th><th class="kb-th kb-th-num">Días esperando</th>
      </tr></thead>
      <tbody>
        <tr class="kb-tr" *ngFor="let f of filas">
          <td class="kb-td">{{ f.code }}</td>
          <td class="kb-td"><span class="kb-td-mono">{{ f.venta }}</span></td>
          <td class="kb-td">{{ f.cliente || '—' }}<span class="kb-td-sub block">{{ f.cedula }}</span></td>
          <td class="kb-td tabular-nums">{{ f.orden }} de {{ f.de }}</td>
          <td class="kb-td kb-td-num">$ {{ f.monto_original | number:'1.2-2':'es' }}</td>
          <td class="kb-td kb-td-num font-semibold"><app-monto-bs [usd]="f.abonado" [bs]="bs(f.abonado)" [tasa]="r.tasa_bcv"></app-monto-bs></td>
          <td class="kb-td kb-td-num"><app-monto-bs [usd]="f.falta" [bs]="bs(f.falta)" [tasa]="r.tasa_bcv"></app-monto-bs></td>
          <td class="kb-td kb-td-num">{{ f.abonos }}</td>
          <td class="kb-td tabular-nums">{{ f.primer_abono | date:'dd/MM/yy HH:mm' }}</td>
          <td class="kb-td tabular-nums">{{ f.ultimo_abono | date:'dd/MM/yy HH:mm' }}</td>
          <td class="kb-td kb-td-num">{{ f.dias }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="flex items-center justify-between gap-3 px-[24px] py-[14px]" *ngIf="filas.length">
    <span class="kb-hint">{{ filas.length }} de {{ cuotasVistas }} cuota(s)</span>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" *ngIf="r.siguiente" (click)="buscar(true)" [disabled]="cargando">{{ cargando ? 'Cargando…' : 'Ver más' }}</button>
  </div>
</section>
